module.exports = __webpack_public_path__ + "assets/50b5905c78365198cc2596e78cf7b7b7.png";